<template lang="pug">
.vip-container(:class="{ 'ios-app': iOSAPP, loading }")
  FlexModal(
    :title="'领取一张' + (toReceiveCoupon ? toReceiveCoupon.title : '')",
    ref="modal",
    :show-cancel="false",
    btn-text="领取",
    @confirm="receiveCoupon",
    color="#DD4C47"
  )
    .modal-text(slot="body")
      .display-coupon(v-if="toReceiveCoupon")
        .left
          .price
            span.amount {{toReceiveCoupon.currentPrice}}
            span.unit 元
          .subtitle {{toReceiveCoupon.subtitle}}
        .right
          .title {{toReceiveCoupon.title}}
          .expire 领取后有效期{{toReceiveCoupon.detail.propEffectiveDays}}天
  common-header.header(
    title="省钱会员",
    color="#242729",
    ref="header",
    left-black-when-active,
    left-black-when-inactive
  )
    template(slot="right")
      PopMenuButton(icon="more", :menus="menus", @clickItem="clickMenu")
  .bg
    img.bg-img(
      src="https://m.hellobike.com/resource/helloyun/15979/FjIV3Vinci.png"
    )
    .gradient
  .body.module
    .card
      .date(v-show="expirationDate") 有效期至{{ expirationDate | time('YYYY.MM.DD') }}
      .desc {{ hint }}
      .btn.flex-mid 立即续费
    .biz(ref="biz")
      .biz-row(v-for="(row, index) in group2show")
        .biz-item(v-for="(item, idx) in row", @click="scrollToIndex(index*3+idx)")
          template(v-if="loading")
            .biz-icon
          template(v-else)
            img.biz-icon(:src="item.businessType | icon")
          span.biz-name {{ item.groupName }}
          template(v-if="!item.isExclusive")
            span.biz-desc 可用{{ loading ? ' - ' : item.usablePropNum }}张
          template(v-else)
            span.biz-desc 请选择权益
          .biz-remind(v-if="tipIndex===index*3+idx")
            .tip-desc
              span {{item.todayExpirePropNum}}张券今天过期
    .nav(:class="{ active: showNav }", ref="nav", v-show="!loading")
      .nav-item.flex-mid(
        ref="navItem",
        v-for="(item, index) in groupWithBiz",
        :class="{ active: index === activeNav }",
        @click="changeNav(index)"
      )
        img.nav-icon(:src="item.businessType | icon")
        span.nav-name {{ item.groupName }}
    .biz-cards
      .biz-card(
        v-for="group in group",
        :class="group | cardClass",
        ref="group",
        v-if="group.coupons && group.coupons.length > 0"
      )
        .header
          .title {{ group.groupName }}
          .subtitle(v-show="group.propEffectiveDays") 领取后，有效期{{ group.propEffectiveDays }}天
        template(v-if="group.isExclusive")
          .select-hint {{ group.groupDesc }}
          SelectCardGroup(
            :items="group.coupons",
            @ok="selectCoupon",
            :loading="loading"
          )
        template(v-else)
          .coupons(
            v-if="group.coupons && group.coupons.length > 0",
            :class="group | cardClass"
          )
            CouponItem.coupon-item(
              v-for="coupon in group.coupons",
              :key="coupon.id",
              :type="group | couponType",
              :info="coupon",
              :loading="coupon.loading",
              @receive="openReceiveModal(coupon)",
              @use="useCoupon(coupon)"
              @wait="waitCoupon(coupon)"
            )
</template>

<script>
import Toast from '@/components/toast';
import FlexModal from '@/components/flex-modal';
import {
  getVipDetailList,
  getVipStatus,
  receiveVipCoupon,
  confirmProperty,
} from '@/api/vip';
import { getVipBiz } from '@/utils/vip';
import PopMenuButton from '@/components/pop-menu-button';
import CommonHeader from '@/components/common-header';
import { env, Native } from '@hb/NBridge/lib/h5';
import dayjs from 'dayjs';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { VIP_BIZ } from '@/const/vip';
import SelectCardGroup from './components/select-card-group.vue';
import CouponItem from './components/coupon-item.vue';
import {
  ensureUndefinedOrNull,
  getTokenAndKey,
  scrollToMid,
  smoothScroll,
  tryCatch,
  onceWrapper,
  commonGoLink,
  isPreRender,
  getSource,
} from '../../utils';
import {
  COUPON_STATUS,
  COUPON_BUTTON_MAP,
  COUPON_ORIGIN_STATUS_MAP,
} from './consts';

const menus = [
  {
    name: '会员规则',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/bf77f80d-7f44-432a-97b2-a1b4a2027ae0.svg',
  },
  {
    name: '购买记录',
    icon:
      'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/5cdbe2d7-c086-4394-8012-80beb4b09fa6.svg',
  },
];

const fill = (n) => Array.from({ length: n }, (_, id) => ({ id, loading: true }));

const receiveOnce = onceWrapper(() => {
  UBT.moduleExpose({
    pageId: 'platform_PaidMemberDetail',
    categoryId: 'platform',
    moduleId: 'platform_receive',
    contentId: 'platform_receive',
    exposureTimes: 1,
    businessInfo: {
      adsource: getSource(),
    },
  });
});

const useOnce = onceWrapper(() => {
  UBT.moduleExpose({
    pageId: 'platform_PaidMemberDetail',
    categoryId: 'platform',
    moduleId: 'platform_ToUse',
    contentId: 'platform_ToUse',
    exposureTimes: 1,
    businessInfo: {
      adsource: getSource(),
    },
  });
});

const LOADING_GROUP = [
  {
    groupName: '单车权益',
    loading: true,
    isExclusive: true,
    businessType: null,
    coupons: fill(2),
  },
  {
    groupName: '打车权益',
    loading: true,
    businessType: 2,
    coupons: fill(3),
  },
  {
    groupName: '顺风车权益',
    loading: true,
    businessType: 3,
    coupons: fill(2),
  },
  {
    groupName: '火车票权益',
    loading: true,
    businessType: 4,
    coupons: fill(1),
  },
  {
    groupName: '酒店权益',
    loading: true,
    businessType: 5,
    coupons: fill(4),
  },
  {
    groupName: '景点门票权益',
    loading: true,
    businessType: 6,
    coupons: fill(1),
  },
];

function CouponMapper(coupon) {
  const {
    propName: title,
    propDesc: desc,
    propAmount: currentPrice,
    propTag,
    status,
    propNum,
    propEndTime,
  } = coupon;

  // 领取埋点
  if (status === COUPON_STATUS.receive) {
    receiveOnce();
  }
  // 去使用埋点
  if (status === COUPON_STATUS.useOnce) {
    useOnce();
  }

  const item = {
    corner: propTag ? '首单神券' : '',
    currentPrice,
    title,
    subtitle: '无门槛',
    desc,
    id: Math.random(),
    btnName: COUPON_BUTTON_MAP[status] || '已作废',
    status: COUPON_ORIGIN_STATUS_MAP[status] || COUPON_STATUS.expired,
    num: propNum || 0,
    detail: coupon,
  };
  if (propEndTime) {
    item.time = `${dayjs(propEndTime).format('YYYY.MM.DD')}到期`;
  }
  return item;
}
export default {
  components: {
    PopMenuButton,
    CommonHeader,
    SelectCardGroup,
    CouponItem,
    FlexModal,
  },
  filters: {
    couponType(v) {
      if (v.businessType === VIP_BIZ.BIKE) {
        // 优惠券
        const bool = (v.coupons || []).map((coupon) => coupon.detail && coupon.detail.propType)
          .every((num) => num === 2);
        if (bool) {
          return VIP_BIZ.BIKE;
        }
      }
      return Math.min(3, v.coupons.length);
    },
    icon(biz) {
      return {
        1: 'https://m.hellobike.com/resource/helloyun/15979/wQs6zSg6Oq.png',
        2: 'https://m.hellobike.com/resource/helloyun/15979/JZvoIw7pu_.png',
        3: 'https://m.hellobike.com/resource/helloyun/15979/B-F9RxpP0h.png',
        4: 'https://m.hellobike.com/resource/helloyun/15979/kjFrtNWYcn.png',
        5: 'https://m.hellobike.com/resource/helloyun/15979/rFN5ylcLxM.png',
        6: 'https://m.hellobike.com/resource/helloyun/15979/gEd71vbr48.png',
      }[biz] || 'https://m.hellobike.com/resource/helloyun/15979/wQs6zSg6Oq.png';
    },
    cardClass(v) {
      if (!v) {
        return '';
      }
      const biz = ` biz-${v.businessType}`;
      if (!v.coupons || v.coupons.length === 0) {
        return `${biz}`;
      }

      if (v.businessType === VIP_BIZ.BIKE) {
        // 优惠券
        const bool = (v.coupons || []).map((coupon) => coupon.detail && coupon.detail.propType)
          .every((num) => num === 2);
        if (bool) {
          return `type-${v.coupons.length > 1 && 'bike'}`;
        }
      }
      return `type-${v.coupons.length > 3 ? 'more' : v.coupons.length}${biz}`;
    },
  },
  data() {
    return {
      iOSAPP: env.isIOS && env.isEasyBikeApp,
      activeNav: null,
      showNav: false,
      openVip: false,
      headerHeight: 0,
      navHeight: 0,
      expirationDate: null,
      totalDiscountAmount: null,
      usableDiscountAmount: '——',
      menus,
      loading: true,
      group: LOADING_GROUP,
      vipRecordGuid: null,
      needDayTips: false,
      remainDays: 0,
      toReceiveCoupon: null,
    };
  },
  computed: {
    groupWithBiz() {
      return this.group.filter((g) => g.businessType !== null || g.isExclusive);
    },
    hint() {
      if (this.loading) {
        return '—— 元权益可用';
      }
      const suffix = this.totalDiscountAmount ? `，累计已为您节省${this.totalDiscountAmount}元` : '';
      let prefix = '';
      if (this.needDayTips) {
        prefix = Number(this.remainDays) === 0 ? '将于今天到期' : `将于${ensureUndefinedOrNull(this.remainDays, '-')}天后到期`;
      } else {
        prefix = `${ensureUndefinedOrNull(
          this.usableDiscountAmount,
          '-',
        )}元权益可用`;
      }
      return `${prefix}${suffix}`;
    },
    group2show() {
      return this.groupWithBiz.reduce(
        (res, cur) => {
          const index = res.length - 1;
          if (res[index].length < 3) {
            res[index].push(cur);
          } else {
            res.push([cur]);
          }
          return res;
        },
        [[]],
      );
    },
    tipIndex() {
      return this.group.map((g, i) => {
        if (g.todayExpirePropNum) {
          return i;
        }
        return null;
      }).filter((v) => v !== null)[0];
    },
  },
  beforeRouteEnter(to, form, next) {
    // 进入埋点
    UBT.pageView({
      pageId: 'platform_PaidMemberDetail',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    // 会员规则
    UBT.moduleExpose({
      pageId: 'platform_PaidMemberDetail',
      categoryId: 'platform',
      moduleId: 'platform_MembershipRules',
      contentId: 'platform_MembershipRules',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    // 购买记录
    UBT.moduleExpose({
      pageId: 'platform_PaidMemberDetail',
      categoryId: 'platform',
      moduleId: 'platform_PurchaseRecords',
      contentId: 'platform_PurchaseRecords',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.getData();
    window.addEventListener('scroll', this.scrollHandler);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    getNavHeight() {
      if (!this.navHeight) {
        this.navHeight = this.$refs.nav.getBoundingClientRect().height;
      }
      return this.navHeight;
    },
    getHeaderHeight() {
      if (!this.headerHeight) {
        this.headerHeight = this.$refs.header.$el.getBoundingClientRect().height;
      }
      return this.headerHeight;
    },
    clickMenu(index) {
      if (index === 0) {
        UBT.clickButton({
          pageId: 'platform_PaidMemberDetail',
          buttonName: 'platform_MembershipRules',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        commonGoLink('https://h.c3x.me/1hTVKP', { isRuleLink: true });
      } else if (index === 1) {
        UBT.clickButton({
          pageId: 'platform_PaidMemberDetail',
          buttonName: 'platform_PurchaseRecords',
          categoryId: 'platform',
          businessInfo: {
            adsource: getSource(),
          },
        });
        this.$router.push('/vip/history');
      }
    },
    async getData() {
      if (!(await Native.isLogin())) {
        return Promise.resolve();
      }
      const { token } = await getTokenAndKey();
      const worker1 = getVipStatus({ token })
        .then((res) => {
          if (res && res.data) {
            const {
              expirationDate,
              usableDiscountAmount,
              openVip,
              needDayTips,
              remainDays,
              totalDiscountAmount,
            } = res.data || {};
            if (openVip) {
              Object.assign(this, {
                expirationDate,
                usableDiscountAmount,
                openVip,
                needDayTips,
                remainDays,
                totalDiscountAmount,
              });
            }
          }
        })
        .catch(() => null)
        .then(() => {
          this.loading = false;
        });
      const worker2 = getVipDetailList({ token })
        .then((res) => {
          if (res && res.data) {
            const { groupList, vipRecordGuid } = res.data || {};
            this.vipRecordGuid = vipRecordGuid;
            this.group = (groupList || []).map((item, index) => {
              const {
                groupName,
                isExclusive,
                groupBusinessLine,
                propList,
                propEffectiveDays,
                todayExpirePropNum,
                usablePropNum,
                groupDesc,
              } = item;
              return {
                groupName,
                isExclusive,
                propEffectiveDays,
                todayExpirePropNum,
                usablePropNum,
                groupDesc,
                businessType: getVipBiz(groupBusinessLine) || (isExclusive ? `isExclusive-${index}` : null),
                coupons: (propList || []).map(CouponMapper),
              };
            });
          }
        })
        .catch(() => null)
        .then(() => {
          this.loading = false;
        });

      return Promise.all([worker1, worker2]);
    },
    async selectCoupon(item) {
      if (item && item.detail) {
        const { token } = await getTokenAndKey();
        const { goodsPropGuid } = item.detail;
        confirmProperty({
          token,
          goodsPropGuid,
          vipRecordGuid: this.vipRecordGuid,
        })
          .catch((e) => Toast.showError(e))
          .then(() => {
            this.getData();
          });
      }
    },
    openReceiveModal(item) {
      this.toReceiveCoupon = item;
      this.$refs.modal.open();
    },
    async receiveCoupon(cp) {
      const coupon = this.toReceiveCoupon || cp;
      if (!coupon) {
        return;
      }

      UBT.clickButton({
        pageId: 'platform_PaidMemberDetail',
        buttonName: 'platform_receive',
        categoryId: 'platform',
        businessInfo: {
          BatchId: coupon.detail.propCode || '',
          adsource: getSource(),
        },
      });
      const { token } = await getTokenAndKey();
      const { userVipPropGuid, propCode, propName } = coupon.detail;
      receiveVipCoupon({
        token, userVipPropGuid, propCode, propName,
      })
        .then(() => {
          Toast.show('领取成功');
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .then(() => {
          this.getData();
        });
    },
    useCoupon(coupon) {
      if (coupon && coupon.detail && coupon.detail.propUrl) {
        UBT.clickButton({
          pageId: 'platform_PaidMemberDetail',
          buttonName: 'platform_ToUse',
          categoryId: 'platform',
          businessInfo: {
            BatchId: coupon.detail.propCode || '',
            adsource: getSource(),
          },
        });
        window.location.href = coupon.detail.propUrl;
      }
    },
    waitCoupon(coupon) {
      if (coupon && coupon.detail && coupon.detail.receiveStartTime) {
        // 当前时间
        const startTime = +new Date();
        // 领取开始时间
        const endTime = coupon.detail.receiveStartTime;
        // 相差时间
        const diff = endTime - startTime;
        if (diff > 0) {
          const day = Math.ceil(diff / (24 * 60 * 60 * 1000));

          Toast.show(`${day}天后可领取此立减券`);
        } else {
          this.receiveCoupon(coupon);
        }
      }
    },
    changeNav(index) {
      this.scrollToIndex(index);
      scrollToMid(this.$refs.navItem[index], this.$refs.nav);
    },
    scrollToIndex(index) {
      this.activeNav = index;
      if (index === undefined) {
        return;
      }
      const el = tryCatch(() => this.$refs.group[index], null);
      if (!el) {
        return;
      }
      smoothScroll(
        el.getBoundingClientRect().top
          + window.scrollY
          - this.getHeaderHeight()
          - this.getNavHeight(),
      );
    },
    scrollHandler() {
      if (this.$refs.biz && this.$refs.header) {
        const { top, height } = this.$refs.biz.getBoundingClientRect();
        const headerHerght = this.$refs.header.$el.getBoundingClientRect()
          .height;
        this.showNav = top + height * 0.4 < headerHerght;
      }
    },
  },
  beforeRouteLeave(to, form, next) {
    // 退出埋点
    UBT.pageViewOut({
      pageId: 'platform_PaidMemberDetail',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
};
</script>

<style lang="less" scoped>
.vip-container {
  height: 100vh;
  padding-top: 0.9rem;
  background: white;

  .display-coupon {
    display: flex;
    width: 2.8rem;
    height: 0.82rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/07177/RpcCXUyGhd.svg);
    background-size: 100%;

    .left {
      width: 0.84rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .price {
        .amount {
          font-size: 0.34rem;
          font-weight: 500;
          color: #5d3a26;
          line-height: 0.34rem;
        }

        .unit {
          font-size: 0.13rem;
          font-weight: 600;
          color: #5d3a26;
        }
      }

      .subtitle {
        font-size: 0.12rem;
        color: #5d3a26;
      }
    }

    .right {
      flex: 1;
      padding-left: 0.24rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .title {
        font-size: 0.14rem;
        font-weight: 500;
        color: #5d3a26;
        margin-bottom: 0.02rem;
      }

      .expire {
        font-size: 0.12rem;
        color: #d5261b;
      }
    }
  }

  .module {
    z-index: 2;
    position: relative;
  }

  .ios-app {
    padding-top: 0.44rem;
  }

  .card {
    width: 3.51rem;
    height: 0.98rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/niVAFp-dKD.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    border-radius: 0.12rem;
    position: relative;

    .btn {
      display: none;
      position: absolute;
      width: 0.72rem;
      height: 0.24rem;
      background: #fff3da;
      border-radius: 0.04rem;
      color: rgba(138, 70, 28, 0.88);
      right: 0.12rem;
      top: 0.14rem;
    }

    .date {
      position: absolute;
      top: 0.4rem;
      left: 0.12rem;
      font-size: 0.12rem;
      color: rgba(255, 247, 230, 0.8);
      line-height: 0.17rem;
    }

    .desc {
      position: absolute;
      left: 0.12rem;
      bottom: 0.12rem;
      font-size: 0.12rem;
      color: #fff9ed;
    }
  }

  .biz-cards {
    display: flex;
    flex-direction: column;

    .biz-card {
      background: #fff;
      box-shadow: 0 0.01rem 0.06rem 0 rgba(0, 0, 0, 0.06);
      border-radius: 0.08rem;
      width: 100%;
      padding: 0.16rem 0.12rem;
      box-sizing: border-box;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.08rem;

        .title {
          font-size: 0.18rem;
          color: #242729;
          font-weight: bold;
        }

        .subtitle {
          font-size: 0.12rem;
          color: #5a6066;
        }
      }

      &.type-more {
        padding-right: 0;
        padding-left: 0;

        .header {
          padding: 0 0.12rem;
        }
      }

      &:not(:last-of-type) {
        margin-bottom: 0.08rem;
      }

      .coupons {
        display: flex;

        &.type-2 {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .coupon-item {
            width: 1.6rem;
            max-width: 1.6rem;
            min-width: 1.6rem;
          }
        }

        &.type-3 {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .coupon-item {
            width: 1rem;
            max-width: 1rem;
            min-width: 1rem;
          }
        }

        &.type-bike {
          width: 100%;
          white-space: nowrap;
          overflow-y: auto;

          &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            color: transparent;
          }

          .coupon-item {
            width: 3rem;
            max-width: 3rem;
            min-width: 3rem;
            display: inline-flex;
            margin-right: 0.08rem;
          }

          :last-child {
            margin-right: 0;
          }
        }

        &.type-more {
          width: 100%;
          white-space: nowrap;
          overflow-y: auto;
          padding: 0 0.12rem;

          &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            color: transparent;
          }

          .coupon-item {
            width: 1rem;
            max-width: 1rem;
            min-width: 1rem;
            display: inline-flex;

            &:not(:last-of-type) {
              margin-right: 0.08rem;
            }
          }
        }
      }

      .select-hint {
        margin-top: 0.07rem;
        margin-bottom: 0.12rem;
        font-size: 0.14rem;
        color: #242729;
      }
    }
  }

  .nav {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    top: 0.84rem;
    background: white;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    box-shadow: 0 0.01rem 0.06rem 0 rgba(0, 0, 0, 0.06);
    z-index: 100;
    padding: 0.08rem 0.01rem 0.18rem;
    white-space: nowrap;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    &.active {
      opacity: 1;
      pointer-events: unset;
    }

    .nav-item {
      flex-direction: column;
      display: inline-flex;
      width: 0.8rem;

      .nav-icon {
        overflow: visible;
        width: 0.36rem;
      }

      .nav-name {
        font-size: 0.12rem;
        font-weight: bold;
        color: #5d3a26;
        margin-top: 0.08rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 110%;
        padding: 1px 0.06rem;
        transition: all 0.2s ease;
      }

      &.active {
        .nav-name {
          background: #8f5c33;
          border-radius: 0.09rem;
          color: white;
        }
      }
    }
  }

  .biz {
    width: 3.51rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;

    .biz-row {
      display: flex;
      justify-content: flex-start;

      &:not(:last-of-type) {
        margin-bottom: 0.16rem;
      }
    }

    .biz-item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      width: 33.33%;

      .biz-icon {
        width: 0.36rem;
        height: 0.36rem;
        background: #f0f3f5;
        border-radius: 50%;
      }

      .biz-name {
        font-size: 0.12rem;
        font-weight: 700;
        color: rgba(36, 39, 41, 0.8);
        margin-top: 0.08rem;
        margin-bottom: 0.02rem;
      }

      .biz-desc {
        font-size: 0.12rem;
        color: #879099;
      }

      .biz-remind {
        position: absolute;
        background: #242729;
        border-radius: 0.04rem;
        opacity: 0.9;
        z-index: 3;
        bottom: -0.25rem;

        .tip-desc {
          padding: 0.02rem 0.08rem;
          color: #fff;
          font-size: 0.12rem;

          &::before {
            content: "";
            width: 0;
            height: 0;
            border-left: 0.05rem solid transparent;
            border-right: 0.05rem solid transparent;
            border-bottom: 0.05rem solid rgba(36, 39, 41, 0.9);
            position: absolute;
            top: -0.05rem;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
      }
    }
  }

  .bg {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background: #f7f9fa;

    img {
      background-repeat: no-repeat;
      background-position-y: 0;
      background-size: 100%;
      background-color: #f0f3f5;
      pointer-events: none;
    }

    .bg-img {
      max-height: 1.9rem;
    }

    .gradient {
      height: 6.48rem;
      position: relative;
      top: -0.26rem;
      background: linear-gradient(180deg, #fff 0%, #f7f9fa 100%);
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding: 0.1rem 0.12rem 0.4rem;
  }
}
</style>
